import * as Components from './global-components';

export default {
  install(app) {
    Object.entries(Components).forEach(([name, component]) => app.component(name, component));
  },
};
